import React, { Component } from 'react';
import ReactSnackBar from "react-easy-snackbar";
import './notificacao.styles.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as commonActions from '../../app/common/common.action';


class NotificacaoComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            id: props.id,
            mensagem: props.mensagem,
            timeout: props.timeout,
            tipo: props.tipo,
            minWidth: props.minWidth,
        }
    }

    removeAlerta() {
        this.setState({
            visible: false,
        })
        this.timeoutClose = null;        
    }

    componentDidUpdate(_prevProps, _prevState) {
        if (this.props.mensagem && this.props.tipo && this.props.timeout && !this.timeoutClose && this.state.id !== this.props.id) {
            
            this.setState({ 
                id: this.props.id,
                visible: !this.state.visible
            });            

            this.timeoutClose = setTimeout(() => {
                this.removeAlerta();
            }, this.props.timeout)
        }
    }

    render() {

        var icon = null;
        switch (this.props.tipo) {
            case "sucesso":
                icon = <span ><i className="mv-basico-confirmar"></i></span>
                break;
            case "erro":
                icon = <span><i className="mv-basico-erro"></i></span>
                break;
            case "alerta":
                icon = <span><i className="mv-basico-alerta"></i></span>
                break;
            default:
                icon = <span><i className="mv-basico-alerta"></i></span>
                break;
        }

        return (
            <div id="toast-alert" className={"snack react-snack-bar-" + this.props.tipo} onClick={() => { this.removeAlerta() }} data-toggle="tooltip" title={this.props.mensagem}>
                <ReactSnackBar Icon={icon} Show={this.state.visible} minWidth={this.props.minWidth}>
                    {this.props.mensagem}
                </ReactSnackBar>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        id: state.commonReducer.idAlerta,
        mensagem: state.commonReducer.mensagemAlerta,
        timeout: state.commonReducer.timeoutAlerta,
        tipo: state.commonReducer.tipoAlerta,
        minWidth: state.commonReducer.minWidth,
    }
}

const mapDispacthToProps = (dispatch) => {
    return {
        commonActions: bindActionCreators(commonActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispacthToProps)(NotificacaoComponent);


// WEBPACK FOOTER //
// ./src/componentes/notificacao/notificacao.component.js